import {styled} from "@mui/material/styles"
import Button from "@mui/material/Button"

const StandardCloseButton = styled(Button)`
    && {
        padding: 0;
        text-align: right;
        overflow-wrap: anywhere;
        background: ${({theme}) => theme.colours.utilities.backgroundAccent};
        color: ${({theme}) => theme.colours.text.hyperlink};
        font-family: ${({theme}) => `${theme.colours.typography.body3.fontFamily}, ${theme.colours.font.default}`};
        font-weight: ${({theme}) => theme.colours.typography.body3.fontWeight};
        letter-spacing: ${({theme}) => theme.colours.typography.body3.letterSpacing};
        border-radius: 0;
        border: 0;

        &:hover,
        &:active {
            background: ${({theme}) => theme.colours.utilities.backgroundAccent};
            border: 0;
        }

        &:focus {
            border: 0;
            border-radius: 0;
        }
    }
`

export default StandardCloseButton
